import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import {
  readCookieConsent,
  saveCookieConsent,
} from '../lib/consent.js';

export default function CookieConsent() {
  const [choice, setChoice] = useState(readCookieConsent);

  const choose = (value) => {
    saveCookieConsent(value);
    setChoice(value);
  };

  if (choice) return null;

  return (
    <section
      role="dialog"
      aria-label="Preferências de privacidade"
      aria-live="polite"
      className="fixed inset-x-3 bottom-3 z-[100] mx-auto max-w-4xl rounded-xl border border-border-strong bg-surface-solid p-4 shadow-[var(--shadow-lg)] sm:p-5"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-accent-soft text-accent">
            <ShieldCheck size={20} aria-hidden="true" />
          </span>
          <div>
            <h2 className="text-sm font-700 text-text">Sua privacidade importa</h2>
            <p className="mt-1 text-sm text-text-secondary">
              Usamos armazenamento essencial para a sessão e, com sua permissão,
              dados de uso para melhorar o Feed ERP. Você pode rejeitar sem perder funcionalidades.{' '}
              <Link className="font-600 text-accent hover:underline" to="/privacidade">
                Ler a Política de Privacidade
              </Link>
            </p>
          </div>
        </div>
        <div className="flex shrink-0 flex-col-reverse gap-2 sm:flex-row">
          <button type="button" className="btn-ghost" onClick={() => choose('rejected')}>
            Apenas essenciais
          </button>
          <button type="button" className="btn-primary" onClick={() => choose('accepted')}>
            Aceitar
          </button>
        </div>
      </div>
    </section>
  );
}
